import React, { PureComponent } from 'react'

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import { makeStyles } from '@material-ui/core/styles';

class FloatingButton extends PureComponent {


  render() {

    const useStyles = makeStyles(() => ({
      fab: {
        width: 500,
        position: 'relative',
        minHeight: 200,
      }
    }));

    return (
      <Fab onClick={this.props.onClick} disabled={this.props.disabled} aria-label={this.props.label} color={this.props.color} className={useStyles.fab}>
        <AddIcon />
      </Fab>
    );
  }
}

export default FloatingButton;